module.exports = __webpack_public_path__ + "ath_game_web/img/Instagram_Logo.c097110b.png";